import(/* webpackMode: "eager" */ "/home/ubuntu/shoptrendz/src/app/ask-ai/page.tsx");
